import React, { useEffect } from "react";
import Tab from "./Tab";
import './TabComponent.scss'
import { useState } from "react";
const TabsComponent = (
    {
        defaultId = '',
        tabsArray,
        tabsContentObject,
        onSetTab,
    }
) => {
   
   const [ currentTabId, setCurrentTabId ] = useState(defaultId)

   useEffect(() => {
    setCurrentTabId(defaultId)
  }, [defaultId])

   const onClickTabHandler = (id) => {
     setCurrentTabId(id);
     onSetTab?.(id)
   }

   const renderTabs = () => {
       return tabsArray.map((tab) => {
            return <Tab isActive={tab.id === currentTabId} onTabClick={onClickTabHandler} {...tab}/>
       })
   }


  const renderOutlet = () => {
    return tabsContentObject[currentTabId] ? tabsContentObject[currentTabId] : null
  }

  return (
    <div className="tab-component-wrapper">
        <div className="tab-component-tabs-wrapper">
           {renderTabs()}
        </div>
        <div className="tab-component-outlet">
            {renderOutlet()}
        </div>
    </div>
  );
};
export default TabsComponent;